import { apiPost, apiGet } from '../../utils/api';
import React, { useState } from 'react';
import { Phone, CheckCircle, XCircle } from 'lucide-react';
import { toast } from 'react-hot-toast';

const PhoneValidator = () => {
  const [phone, setPhone] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleValidate = async () => {
    setLoading(true);
    setResult(null);
    try {
      const data = await apiPost('/api/utils/phone-validator', { phone });
      setResult(data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white rounded-lg shadow p-6 mt-6">
      <div className="flex items-center gap-2 mb-4">
        <Phone className="w-6 h-6 text-gray-700" />
        <h1 className="text-2xl font-bold text-gray-900">Validador de Telefone</h1>
      </div>
      <p className="text-gray-700 mb-4">Valide números de telefone brasileiros e internacionais. Verifica formato, código do país e estrutura do número.</p>
      <div className="mb-4">
        <input
          type="text"
          className="w-full border rounded p-2 text-gray-900 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Digite o número de telefone..."
          value={phone}
          onChange={e => setPhone(e.target.value)}
        />
      </div>
      <button
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded transition mb-4 flex items-center gap-2 disabled:opacity-60"
        onClick={handleValidate}
        disabled={!phone.trim() || loading}
      >
        {loading && <span className="loader border-white" />}
        Validar
      </button>
      {result && (
        <div className={`mt-4 p-4 rounded-lg border ${result.valid ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
          <div className="flex items-center gap-2 mb-2">
            {result.valid ? (
              <CheckCircle className="w-5 h-5 text-green-600" />
            ) : (
              <XCircle className="w-5 h-5 text-red-600" />
            )}
            <span className={`font-semibold ${result.valid ? 'text-green-800' : 'text-red-800'}`}>
              {result.valid ? 'Telefone Válido' : 'Telefone Inválido'}
            </span>
          </div>
          <div className="text-sm text-gray-700">
            <p><strong>Número:</strong> {result.formatted || phone}</p>
            {result.country && <p><strong>País:</strong> {result.country}</p>}
            {result.type && <p><strong>Tipo:</strong> {result.type}</p>}
            {result.error && <p className="text-red-600"><strong>Erro:</strong> {result.error}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default PhoneValidator; 